<template>
  <a-rate v-model:value="rateValue" @change="rateChange" :disabled="disabled" allow-half></a-rate>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue'

const props = defineProps({
  disabled: {
    required: true,
    type: Boolean,
    default: false
  },
  value: {
    required: true,
    type: Number,
    default: 0
  },
  update: {
    required: true,
    type: Boolean,
    default: false
  }
})

const rateValue = ref(0)

const emit = defineEmits(['update:value', 'updataMatrixScore'])
const rateChange = (val: number) => {
  if (props.update) {
    emit('update:value', val)
    emit('updataMatrixScore', val)
  }
}
onMounted(async () => {
  if (props.value > 0) {
    rateValue.value = Number(props.value)
  }
})
</script>

<style lang="less" scoped>
.ant-rate {
  display: flex;
  gap: 12px;
  :deep(.ant-rate-star) {
    font-size: 24px;
    margin: 0;
  }
}
:deep(.ant-rate-star-zero) {
  .anticon {
    color: rgb(231, 231, 231) !important;
  }
}
:deep(.ant-rate-star-active) {
  .ant-rate-star-second {
    .anticon {
      color: rgb(231, 231, 231);
    }
  }
}
</style>
